import React, { Fragment, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Toolbar, AppBar, Typography, Backdrop, CircularProgress } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { analyticActions } from '_actions';
import Filter from './components/Filter';
import CartLeadsInByTime from './components/Carts/CartLeadsInByTime';
import CartLeadsInDepartmentByTime from './components/Carts/CartLeadsInDepartmentByTime';
import LeadsByCountryAndDept from './components/Carts/LeadsByCountryAndDept';
import Recap from './components/Recap';


const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        marginRight: ({ opened }) => opened ? "400px" : 0,
    },
    spacer: {
        flexGrow: 1
    },
    backdrop: {
        zIndex: theme.zIndex.drawer - 1,
        color: '#fff',
    },
}));

const Analytics3 = () => {

    const [opened, setOpened] = useState(sessionStorage.getItem('analyticsFiltersOpened') === 'true');
    const handleOpenchange = (opened) => {
        setOpened(opened);
    }
    const classes = useStyles({ opened: opened });
    const cartData = useSelector(state => state.analytics.cart3)

    const { loading } = useSelector(state => state.analytics)
    const dispatch = useDispatch();

    const [filters, setFilters] = useState();

    const handleFiltersChange = (filters) => {
        setFilters(filters);
    }

    useEffect(() => {
        const ff = { ...filters };
        if (typeof ff.startDate !== "undefined") {
            // ff.from = ff.startDate === "" ? '1900-01-01' : ff.startDate;
            ff.from = ff.startDate;
        }
        if (typeof ff.endDate !== "undefined") {

            // ff.to = ff.endDate === "" ? '2500-01-01' : ff.endDate;
            ff.to = ff.endDate;
        }
        delete ff.startDate
        delete ff.endDate

        dispatch(analyticActions.getCart3(ff));
    }, [filters, dispatch]);


    const handleExport = () => {
        dispatch(analyticActions._export(filters));
    }

    return (
        <Fragment>
            <AppBar color="default" position="sticky">
                <Toolbar>
                    <span className={classes.spacer} />
                    <Filter
                        filtersChange={handleFiltersChange}
                        onOpenChange={handleOpenchange}
                        onExportClick={handleExport}
                    />
                </Toolbar>
            </AppBar>
            <div className={classes.root}>
                <Backdrop className={classes.backdrop} open={loading} >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid
                    container
                    spacing={4}
                >

                    <Grid item lg={12} md={12} xl={12} xs={12}>
                        <Recap
                            loading={loading}
                            {...cartData?.totals}
                        />
                    </Grid>

                    <Grid item lg={12} md={12} xl={12} xs={12}>
                        <Typography variant='h4'>LEADS CONVERTED</Typography>
                    </Grid>
                    <Grid item lg={12} md={12} xl={12} xs={12}>
                        <CartLeadsInByTime
                            title="All Leads Converted "
                            subheader="All converted leads compared with previous year"
                            categories={cartData?.leadsConvertedByTime?.categories}
                            series={cartData?.leadsConvertedByTime?.series}
                        />
                    </Grid>
                    <Grid item lg={12} md={12} xl={12} xs={12}>
                        <CartLeadsInDepartmentByTime
                            title="Converted Leads By Source"
                            subheader="All converted leads by source"
                            categories={cartData?.leadsConvertedSourceByTime?.categories}
                            series={cartData?.leadsConvertedSourceByTime?.series}
                            stacked={false}
                            stackChangeable={true}
                        />
                    </Grid>

                    <Grid item lg={12} md={12} xl={12} xs={12}>
                        <CartLeadsInDepartmentByTime
                            title="Converted Leads By Website"
                            subheader="All converted leads by Website"
                            categories={cartData?.leadsConvertedWebsiteByTime?.categories}
                            series={cartData?.leadsConvertedWebsiteByTime?.series}
                            stacked={true}
                            stackChangeable={true}
                        />
                    </Grid>



                    <Grid item lg={12} md={12} xl={12} xs={12}>
                        <CartLeadsInDepartmentByTime
                            title="Converted Leads By Practice"
                            subheader="All converted leads assigned to a department"
                            categories={cartData?.leadsConvertedDepartmentByTime?.categories}
                            series={cartData?.leadsConvertedDepartmentByTime?.series}
                            stacked={false}
                            stackChangeable={true}
                        />
                    </Grid>


                    <Grid item lg={12} md={12} xl={12} xs={12}>
                        <Typography variant='h4'>CONVERTED LEADS BY COUNTRY</Typography>
                    </Grid>
                    {cartData?.leadsConvertedDepartmentsByJurisdiction && cartData.leadsConvertedDepartmentsByJurisdiction.map((v, k) => {
                        return (
                            <Grid item lg={6} key={k}>
                                <LeadsByCountryAndDept
                                    key={k}
                                    categories={v.categories}
                                    series={v.series.data}
                                    name={v.name}

                                    withJurisdiction={v.withJurisdiction}
                                    withoutJurisdiction={v.withoutJurisdiction}
                                />
                            </Grid>
                        )
                    })}
                </Grid>
            </div>
        </Fragment>
    );
};

export { Analytics3 };
